<template>
  <div v-if="questoesOptions">
    <FormSelectMultipleGroup
      label="Questões"
      :grupoConteudoId="grupoConteudoId"
      :options="questoesOptions"
      groupValues="questoes"
      groupLabel="text"
      :groupSelect="groupSelect"
      :scope="scope"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
    />
  </div>
</template>

<script>
import string from "~/filters/string";
import FormSelectMultipleGroup from "~/components/UIComponents/Forms/FormSelectMultipleGroup";
import TemaService from "~/domain/prova/TemaService";

export default {
  name: "form-select-multiple-group-questao",
  components: {
    FormSelectMultipleGroup
  },
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: Array,
    options: Array,
    groupValues: String,
    groupLabel: String,
    groupSelect: {
      type: Boolean,
      default: true
    },
    grupoConteudoId: Number,
    questoesResult: Array
  },
  filters: {
    ...string
  },
  data() {
    return {
      active: false,
      messages: {
        noOptions: "Nenhuma opção disponível"
      },
      questoes: [],
      questoesOptions: []
    };
  },
  mounted() {
    this.$el.value = this.value;
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  asyncComputed: {
    questoesOptions() {
      let temas = [];
      let questoesOptions = [];

      this.questoesResult.map(result => {
        let { id, nome } = result.temaQuestaos[0].tema;
        temas.push({ id, text: nome });
      });

      temas = temas.filter(function(a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null));

      temas.sort(this.compare);

      temas.map(tema => {
        let temaObject = {
          text: tema.text,
          value: tema.id,
          questoes: []
        };
        this.questoesResult.map(questao => {
          if (questao.temaQuestaos[0].tema.id === tema.id) {
            temaObject.questoes.push({
              text: this.$options.filters.clearTags(questao.titulo),
              value: questao.id
            });
          }
        });

        questoesOptions.push(temaObject);
      });

      return questoesOptions;
    }
  },
  methods: {
    compare(a, b) {
      let comparison = 0;

      if (a.text > b.text) {
        comparison = 1;
      } else if (a.text < b.text) {
        comparison = -1;
      }

      return comparison;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormSelectMultipleGroupQuestao.vue